/* eslint-disable @typescript-eslint/no-unsafe-return -- ok for this file, a lot of arbitrary values possible */
/* eslint-disable @typescript-eslint/no-unsafe-call -- ok for this file, a lot of arbitrary values possible */
/* eslint-disable @typescript-eslint/no-unsafe-member-access -- ok for this file, a lot of arbitrary values possible */
/* eslint-disable @typescript-eslint/no-unsafe-argument -- ok for this file, a lot of arbitrary values possible */
/* eslint-disable @typescript-eslint/no-unsafe-assignment -- ok for this file, a lot of arbitrary values possible */
import { Actions, ofType } from '@ngrx/effects';
import { Action, DefaultProjectorFn, MemoizedSelector, Store, select } from '@ngrx/store';

import { CrudOperationType, CrudServiceParams, IdName, SafariBulkObject, SafariObject, SafariObjectId } from '@safarilaw-webapp/shared/common-objects-models';

import { Observable, Subscription, distinctUntilChanged, filter, mergeMap, of, race, take, tap } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import {
  ActionErrorBase,
  ActionOptions,
  DeleteMultipleObjectsActionInfo,
  DeleteObjectActionInfo,
  LoadObjectActionFailInfo,
  LoadObjectActionInfo,
  LoadObjectListActionInfo,
  UpdateObjectListActionFailInfo,
  UpdateOrCreateActionFailInfo,
  UpdateOrCreateActionInfo,
  UpdateOrCreateMultipleActionInfo
} from '../models/object';
import { ISafariObjectState, SafariObjectList } from '../state/interface';
import { ActionExtensions } from '../state/reducer';
import { IReduxProvider, SafariReduxDropdownObject, SafariReduxSearchDefinition } from '../state/redux-generator';
import { SelectorState } from '../state/selectors/enums';
export class ActionOverrides {
  actionId?: string;
  options?: ActionOptions;
}

export const abortOnError =
  () =>
  <T>(source: Observable<T>): Observable<T> =>
    new Observable(subscriber => {
      const subscription = source.subscribe({
        next: value => {
          // We are going to pipe this to either updateObject or fileUpload
          // objects get 'error' property appended if there is API failure
          // 'errors' if form validation error
          // and files have hadErrors (api error) or wasCancelled (user clicked cancel) property
          // We'll need to simplify these names at the very least to 'errors' and 'wasCancelled'
          if (value['error'] || value['errors'] || value['hadErrors'] || value['wasCancelled']) {
            subscriber.error(new AbortSave());
          } else {
            subscriber.next(value);
          }
        },
        error: error => {
          subscriber.error(error);
        },
        complete: () => {
          subscriber.complete();
        }
      });

      return () => subscription.unsubscribe();
    });
export class AbortSave {
  constructor(public returnValue: any = null) {}
}

type ObserveObjectOptions =
  | {
      filterNull: boolean;
      selectorState: SelectorState;
    }
  | boolean
  | SelectorState;

class SafariObjectListIdForDataAccessService {
  id?: SafariObjectId;
  filter?: CrudServiceParams;
  listKey?: string;
}

export interface DataAccessCallbacks {
  onLoadObjectFail(action: LoadObjectActionFailInfo & Action<string>): void;
  onLoadObjectListFail(action: ActionErrorBase & Action<string>): void;
  onDeleteObjectFail(object: IReduxProvider<any, any>, id: any): void;
  onDeleteObjectSuccess(object: IReduxProvider<any, any>, id: any): void;
  onCreateOrUpdateObjectFail(action: LoadObjectActionFailInfo & Action<string>): void;
  onCreateOrUpdateMultipleObjectsFail(action: LoadObjectActionFailInfo & Action<string>): void;
  onUpdateObjectListFail(action: UpdateObjectListActionFailInfo<any> & Action<string>): void;
}

export class DataAccessService {
  private _pendingLoadListActions: Map<IReduxProvider<any, any>, any> = new Map<IReduxProvider<any, any>, any>();
  private _pendingLoadObjectActions: Map<IReduxProvider<any, any>, any> = new Map<IReduxProvider<any, any>, any>();
  private _pendingLoadObjectBlockUiActions: Map<IReduxProvider<any, any>, any> = new Map<IReduxProvider<any, any>, any>();
  private _pendingDeleteObjectActions: Map<IReduxProvider<any, any>, any> = new Map<IReduxProvider<any, any>, any>();
  private _pendingCreateUpdateObjectActions: Map<IReduxProvider<any, any>, any> = new Map<IReduxProvider<any, any>, any>();
  private _pendingUpdateObjectListActions: Map<IReduxProvider<any, any>, any> = new Map<IReduxProvider<any, any>, any>();

  private _loadListCompleteSubscriptions: Map<string | IReduxProvider<any, any>, Subscription> = new Map<string, Subscription>();
  private _loadObjectCompleteSubscriptions: Map<string | IReduxProvider<any, any>, Subscription> = new Map<string, Subscription>();
  private _updateObjectCompleteSubscriptions: Map<string | IReduxProvider<any, any>, Subscription> = new Map<string, Subscription>();
  private _updateObjectListCompleteSubscriptions: Map<string | IReduxProvider<any, any>, Subscription> = new Map<string, Subscription>();
  private _deleteObjectCompleteSubscriptions: Map<string | IReduxProvider<any, any>, Subscription> = new Map<string, Subscription>();

  searchReduxObject: SafariReduxSearchDefinition<any>;

  constructor(
    private _store: Store<unknown>,
    private _actions: Actions<unknown>,
    private _host: DataAccessCallbacks
  ) {}

  private _addactionIdToActionOverrides<T>(overrides: UpdateOrCreateActionInfo<T> = null) {
    const actionId = overrides?.actionId || uuidv4();
    if (overrides == null) {
      overrides = {
        actionId
      };
    } else {
      overrides.actionId = actionId;
    }
    return overrides;
  }
  private _addactionIdToActionOverridesMulitple<T>(overrides: UpdateOrCreateMultipleActionInfo<T> = null) {
    const actionId = overrides?.actionId || uuidv4();
    if (overrides == null) {
      overrides = {
        actionId
      };
    } else {
      overrides.actionId = actionId;
    }
    return overrides;
  }
  private _addToPendingListAction(list: Map<IReduxProvider<any, any>, any>, ctr, actionId) {
    let current = list.get(ctr);
    if (current == null) {
      list.set(ctr, []);
      current = list.get(ctr);
    }
    current.push(actionId);
  }
  private _removeFromPendingListAction(list: Map<IReduxProvider<any, any>, any>, ctr, actionId) {
    const current = list.get(ctr);
    if (current == null) {
      return;
    }
    const index = current.indexOf(actionId);
    if (index !== -1) {
      current.splice(index, 1);
    }
    if (current.length === 0) {
      list.delete(ctr);
    }
  }
  private _addToPendingLoadListAction(ctr, actionId) {
    this._addToPendingListAction(this._pendingLoadListActions, ctr, actionId);
  }
  private _addToPendingUpdateObjectListAction(ctr, actionId) {
    this._addToPendingListAction(this._pendingUpdateObjectListActions, ctr, actionId);
  }
  private _addToPendingLoadObjectAction(ctr, actionId) {
    this._addToPendingListAction(this._pendingLoadObjectActions, ctr, actionId);
  }
  private _addToPendingCreateUpdateObjectAction(ctr, actionId) {
    this._addToPendingListAction(this._pendingCreateUpdateObjectActions, ctr, actionId);
  }
  private _addToPendingDeleteObjectAction(ctr, actionId) {
    this._addToPendingListAction(this._pendingDeleteObjectActions, ctr, actionId);
  }
  private _removeFromPendingLoadListAction(ctr, actionId) {
    this._removeFromPendingListAction(this._pendingLoadListActions, ctr, actionId);
  }
  private _removeFromPendingLoadObjectAction(ctr, actionId) {
    this._removeFromPendingListAction(this._pendingLoadObjectActions, ctr, actionId);
  }
  private _removeFromPendingDeleteObjectAction(ctr, actionId) {
    this._removeFromPendingListAction(this._pendingDeleteObjectActions, ctr, actionId);
  }
  private _removeFromPendingCreateOrUpdateObjectAction(ctr, actionId) {
    this._removeFromPendingListAction(this._pendingCreateUpdateObjectActions, ctr, actionId);
  }
  private _removeFromPendingUpdateObjectListAction(ctr, actionId) {
    this._removeFromPendingListAction(this._pendingUpdateObjectListActions, ctr, actionId);
  }

  observeObject$<T extends SafariObject>(
    object: IReduxProvider<ISafariObjectState<T>, T>,
    id: SafariObjectId,
    options: ObserveObjectOptions = true,
    selectorOptionFilterNull: boolean = true
  ): Observable<T & ActionExtensions & { error?: any }> {
    const allSelectors: MemoizedSelector<object, T, DefaultProjectorFn<T>>[] = [];

    allSelectors[SelectorState.Current] = object.default.selectors.objectInCurrentState(SafariObject.id(id));
    allSelectors[SelectorState.FailedToLoad] = object.default.selectors.objectInFailedState(SafariObject.id(id), CrudOperationType.Retrieve);
    allSelectors[SelectorState.FaiedToDelete] = object.default.selectors.objectInFailedState(SafariObject.id(id), CrudOperationType.Delete);
    allSelectors[SelectorState.FailedToSave] = object.default.selectors.objectInFailedState(SafariObject.id(id), CrudOperationType.Update);
    allSelectors[SelectorState.Saving] = object.default.selectors.objectInSavingState(SafariObject.id(id));
    allSelectors[SelectorState.Saved] = object.default.selectors.objectInSavedState(SafariObject.id(id));
    allSelectors[SelectorState.Loaded] = object.default.selectors.objectInLoadedState(SafariObject.id(id));
    allSelectors[SelectorState.Loading] = object.default.selectors.objectInLoadingState(SafariObject.id(id));
    if (typeof options === 'boolean') {
      return this._store.select(object.default.selectors.objectInCurrentState(SafariObject.id(id))).pipe(filter(o => (options ? o != null : true)));
    } else {
      if (typeof options === 'number') {
        return this._store.select(allSelectors[options]).pipe(filter(o => (selectorOptionFilterNull ? o != null : true)));
      } else {
        return this._store.select(allSelectors[options.selectorState]).pipe(filter(o => (options.filterNull ? o != null : true)));
      }
    }
  }

  loadObject<T extends SafariObject>(object: IReduxProvider<ISafariObjectState<T>, T>, id: SafariObjectId, overrides: LoadObjectActionInfo<T> = null) {
    if (id != null) {
      overrides = this._addactionIdToActionOverrides(overrides);

      this._addToPendingLoadObjectAction(object, overrides.actionId);

      const sub = this._loadObjectCompleteSubscriptions.get(object);
      if (sub == null) {
        this._loadObjectCompleteSubscriptions.set(
          object,
          this._actions
            .pipe(
              ofType(object.default.actions.loadObjectFail, object.default.actions.loadObjectSuccess),
              tap(o => {
                if (o.actionId != null) {
                  this._removeFromPendingLoadObjectAction(object, o.actionId);
                }
                if (o.type == object.default.actions.loadObjectFail.type) {
                  this._host.onLoadObjectFail(o as LoadObjectActionFailInfo & Action<string>);
                }
              })
            )
            .subscribe()
        );
      }
      this._store.dispatch(object.default.actions.loadObject({ ...overrides, payload: { id: SafariObject.id(id) } }));
    }
  }

  loadObjectOnce$<T extends SafariObject>(
    object: IReduxProvider<ISafariObjectState<T>, T>,
    id: SafariObjectId,
    overrides: LoadObjectActionInfo<T> & { observeOptions?: ObserveObjectOptions } = null
  ): Observable<T & ActionExtensions> {
    return this.loadObject$(object, id, overrides).pipe(take(1));
  }

  loadObject$<T extends SafariObject>(
    object: IReduxProvider<ISafariObjectState<T>, T>,
    id: SafariObjectId,
    overrides: LoadObjectActionInfo<T> & { observeOptions?: ObserveObjectOptions } = null
  ): Observable<T & ActionExtensions> {
    if (id == '0') {
      overrides = this._addactionIdToActionOverrides(overrides);
      return new Observable<void>(observer => {
        setTimeout(() => {
          this.loadObject(object, id, { ...overrides });
        });
        observer.next();
        observer.complete();
      }).pipe(
        mergeMap(() =>
          this._actions.pipe(
            ofType(object.default.actions.loadObjectSuccess.type),
            filter(o => o.actionId == overrides.actionId),
            mergeMap(o => of({ ...o.payload, correlationId: o.correlationId, context: o.context })),
            take(1)
          )
        )
      );
    }
    this.loadObject(object, id, overrides);
    if (overrides?.observeOptions == null) {
      return this.observeObject$<T>(object, SafariObject.id(id));
    } else {
      return this.observeObject$<T>(object, SafariObject.id(id), overrides.observeOptions);
    }
  }

  /**
   * Loads an object and hands back what the API answered rather than what the store holds, for an object that keeps
   * no state. With an `original` carrying an `__etag` it is a conditional GET, and a 304 hands `original` back. A
   * failure comes back as the id with `error` set; whether it also reaches the error UI follows `silenceErrors`.
   */
  retrieveObjectOnce$<T extends SafariObject>(object: IReduxProvider<ISafariObjectState<T>, T>, id: SafariObjectId, overrides: LoadObjectActionInfo<T> = null): Observable<T & { error?: any }> {
    overrides = this._addactionIdToActionOverrides(overrides);
    const ok = this._actions.pipe(
      ofType(object.default.actions.loadObjectSuccess),
      filter(o => SafariObject.idEqual(o.actionId, overrides.actionId))
    );
    const fail = this._actions.pipe(
      ofType(object.default.actions.loadObjectFail),
      filter(o => SafariObject.idEqual(o.actionId, overrides.actionId))
    );

    return new Observable<void>(observer => {
      this.loadObject(object, id, overrides);
      observer.next();
      observer.complete();
    }).pipe(
      mergeMap(() =>
        race(ok, fail).pipe(
          mergeMap(o => (o.type == object.default.actions.loadObjectFail.type ? of({ id: SafariObject.id(id), error: (o as ActionErrorBase).error } as T & { error?: any }) : of(o.payload as T))),
          take(1)
        )
      )
    );
  }

  getDefaultLoadListParams() {
    return {
      id: null,
      filter: {
        orderBy: null,
        skip: 0,
        top: 0,
        additionalFilters: new Map<string, string>()
      } as CrudServiceParams,
      additionalInfo: null
    };
  }

  setUpLoadListFailSuccessObservable<T extends SafariObject>(object: IReduxProvider<ISafariObjectState<T>, T>, actionId) {
    this._addToPendingLoadListAction(object, actionId);
    const sub = this._loadListCompleteSubscriptions.get(object);
    if (sub == null) {
      this._loadListCompleteSubscriptions.set(
        object,
        this._actions
          .pipe(
            ofType(object.default.actions.loadObjectListFail, object.default.actions.loadObjectListSuccess),
            tap(o => {
              if (o.actionId != null) {
                this._removeFromPendingLoadListAction(object, o.actionId);
              }
              if (o.type === object.default.actions.loadObjectListFail.type) {
                this._host.onLoadObjectListFail(o as ActionErrorBase & Action<string>);
              }
            })
          )
          .subscribe()
      );
    }
  }
  loadObjectListCount<T extends SafariObject>(
    object: IReduxProvider<ISafariObjectState<T>, T>,
    additionalParams: SafariObjectListIdForDataAccessService = null,
    id: SafariObjectId = null,
    overrides: ActionOverrides = null
  ) {
    if (!additionalParams) {
      additionalParams = this.getDefaultLoadListParams();
    }
    id = id || null;
    overrides = this._addactionIdToActionOverrides(overrides);
    this.setUpLoadListFailSuccessObservable(object, overrides.actionId);
    const options = overrides?.options != null ? { ...overrides.options, countOnly: true } : { countOnly: true };

    this._store.dispatch(object.default.actions.loadObjectList({ actionId: overrides.actionId, payload: { ...additionalParams, id: SafariObject.id(id) }, options }));
  }

  loadObjectList<T extends SafariObject>(object: IReduxProvider<ISafariObjectState<T>, T>, listIdAndFilter: SafariObjectListIdForDataAccessService = null, overrides: LoadObjectListActionInfo = null) {
    if (!listIdAndFilter) {
      listIdAndFilter = this.getDefaultLoadListParams();
    }
    overrides = this._addactionIdToActionOverrides(overrides);
    this.setUpLoadListFailSuccessObservable(object, overrides.actionId);
    this._store.dispatch(
      object.default.actions.loadObjectList({ actionId: overrides.actionId, payload: { ...listIdAndFilter, id: SafariObject.id(listIdAndFilter.id) }, options: overrides?.options ?? null })
    );
  }

  loadObjectList$<T extends SafariObject>(
    objectType: IReduxProvider<ISafariObjectState<T>, T>,
    listIdAndFilter: SafariObjectListIdForDataAccessService = null,
    overrides: LoadObjectListActionInfo & { observeOptions?: ObserveObjectOptions } = null
  ): Observable<SafariObjectList<T> & ActionExtensions> {
    this.loadObjectList(objectType, listIdAndFilter, overrides);
    if (overrides?.observeOptions == null) {
      return this.observeObjectList$<T>(objectType, listIdAndFilter);
    } else {
      return this.observeObjectList$<T>(objectType, listIdAndFilter, overrides.observeOptions);
    }
  }

  observeObjectListCount$<T extends SafariObject>(object: IReduxProvider<ISafariObjectState<T>, T>, listIdAndFilter: SafariObjectListIdForDataAccessService) {
    if (!listIdAndFilter) {
      listIdAndFilter = this.getDefaultLoadListParams();
    }
    return this._store.select(object.default.selectors.objectListInCurrentStateTotalCount({ ...listIdAndFilter, id: SafariObject.id(listIdAndFilter.id) })).pipe(filter(o => o != null));
  }
  /**
   * The object's history as last read or, with FailedToLoad, the failure of its last read. A failed read leaves
   * the history before it in Current, and the next read clears the failure.
   */
  observeObjectHistory$<T extends SafariObject>(
    object: IReduxProvider<ISafariObjectState<T>, T>,
    id: SafariObjectId,
    selectorState: SelectorState.Current | SelectorState.FailedToLoad = SelectorState.Current,
    filterNull = true
  ) {
    const selector: MemoizedSelector<object, any, DefaultProjectorFn<any>> = selectorState == SelectorState.FailedToLoad
      ? object.default.selectors.objectHistoryInFailedState(id)
      : object.default.selectors.objectHistoryInCurrentState(id);
    return this._store.select(selector).pipe(filter(objectHistory => !filterNull || objectHistory != null));
  }

  observeObjectList$<T extends SafariObject>(
    object: IReduxProvider<ISafariObjectState<T>, T>,
    listIdAndFilter: SafariObjectListIdForDataAccessService,
    options: ObserveObjectOptions = true,
    selectorOptionFilterNull = true
  ): Observable<SafariObjectList<T> & ActionExtensions> {
    if (!listIdAndFilter) {
      listIdAndFilter = this.getDefaultLoadListParams();
    }
    const allSelectors: MemoizedSelector<object, SafariObjectList<T>, DefaultProjectorFn<SafariObjectList<T>>>[] = [];
    allSelectors[SelectorState.Current] = object.default.selectors.objectListInCurrentState({ ...listIdAndFilter, id: SafariObject.id(listIdAndFilter.id) });
    allSelectors[SelectorState.FailedToLoad] = object.default.selectors.objectListInFailedState({ ...listIdAndFilter, id: SafariObject.id(listIdAndFilter.id) }, CrudOperationType.Retrieve);
    allSelectors[SelectorState.Loaded] = object.default.selectors.objectListInLoadedState({ ...listIdAndFilter, id: SafariObject.id(listIdAndFilter.id) });
    if (typeof options === 'boolean') {
      return this._store
        .select<SafariObjectList<T>>(object.default.selectors.objectListInCurrentState({ ...listIdAndFilter, id: SafariObject.id(listIdAndFilter.id) }))
        .pipe(filter(o => selectorOptionFilterNull == false || o != null));
    } else {
      if (typeof options === 'number') {
        return this._store.select(allSelectors[options]).pipe(filter(o => (selectorOptionFilterNull ? o != null : true)));
      } else {
        return this._store.select(allSelectors[options.selectorState]).pipe(filter(o => (options.filterNull ? o != null : true)));
      }
    }
  }
  observeDropdowns$<T extends IdName>(dropdown: SafariReduxDropdownObject<any>, id: SafariObjectId): Observable<T[]> {
    const idToObserve = SafariObject.id(id);
    return this._store.select(dropdown.default.selectors.dropdownState(idToObserve)).pipe(
      filter((o: T[]) => o != null),
      distinctUntilChanged((prev, current) => JSON.stringify(prev) == JSON.stringify(current))
    );
  }
  observeSearchResult$(id: string): Observable<any> {
    return this._store.pipe(select(this.searchReduxObject.default.selectors.searchState(id)));
  }

  deleteObject<T extends SafariObject>(object: IReduxProvider<ISafariObjectState<T>, T>, id: SafariObjectId, overrides: DeleteObjectActionInfo<T> = null) {
    if (id != null) {
      overrides = this._addactionIdToActionOverrides(overrides);
      this._addToPendingDeleteObjectAction(object, overrides.actionId);
      const sub = this._deleteObjectCompleteSubscriptions.get(object);
      if (sub == null) {
        this._deleteObjectCompleteSubscriptions.set(
          object,
          this._actions
            .pipe(
              ofType(object.default.actions.deleteObjectFail, object.default.actions.deleteObjectSuccess),
              tap(o => {
                if (o.type === object.default.actions.deleteObjectFail.type) {
                  this._host.onDeleteObjectFail(object, id);
                } else if (o.type === object.default.actions.deleteObjectSuccess.type) {
                  this._host.onDeleteObjectSuccess(object, id);
                }
                if (o.actionId != null) {
                  this._removeFromPendingDeleteObjectAction(object, o.actionId);
                }
              })
            )
            .subscribe()
        );
      }

      this._store.dispatch(
        object.default.actions.deleteObject({ payload: { id: SafariObject.id(id), model: overrides?.payload?.model }, actionId: overrides.actionId, options: overrides?.options ?? null })
      );
    }
  }
  deleteObjects<T extends SafariObject>(object: IReduxProvider<ISafariObjectState<T>, T>, payload: SafariBulkObject<T>, overrides: DeleteMultipleObjectsActionInfo<T> = null) {
    if (payload != null) {
      overrides = this._addactionIdToActionOverridesMulitple(overrides);
      this._addToPendingDeleteObjectAction(object, overrides.actionId);
      const sub = this._deleteObjectCompleteSubscriptions.get(object);
      if (sub == null) {
        this._deleteObjectCompleteSubscriptions.set(
          object,
          this._actions
            .pipe(
              ofType(object.default.actions.deleteObjectFail, object.default.actions.deleteObjectSuccess),
              tap(o => {
                if (o.actionId != null) {
                  this._removeFromPendingDeleteObjectAction(object, o.actionId);
                }
              })
            )
            .subscribe()
        );
      }

      this._store.dispatch(object.default.actions.deleteMultipleObjects({ payload, ...overrides }));
    }
  }

  clearObjectState<T extends SafariObject>(object: IReduxProvider<ISafariObjectState<T>, T>) {
    this._store.dispatch(object.default.actions.clearState());
  }

  deleteMultipleObjectsOnce$<T extends SafariObject>(
    object: IReduxProvider<ISafariObjectState<T>, T>,
    payload: SafariBulkObject<T>,
    overrides: DeleteMultipleObjectsActionInfo<T> = null,
    throwAbortOnError = true
  ): Observable<SafariBulkObject<T> & { error?: any }> {
    overrides = this._addactionIdToActionOverridesMulitple(overrides);

    const ok = this._actions.pipe(
      ofType(object.default.actions.deleteMultipleObjectsSuccess),
      filter(o => o.actionId == overrides.actionId)
    );
    const fail = this._actions.pipe(
      ofType(object.default.actions.deleteMultipleObjectsFail),
      filter(o => o.actionId == overrides.actionId)
    );

    const func = new Observable<void>(observer => {
      this.deleteObjects(object, payload, { ...overrides });
      observer.next();
      observer.complete();
    }).pipe(
      mergeMap(() =>
        race(ok, fail).pipe(
          mergeMap(o => {
            if (o.type === object.default.actions.deleteMultipleObjectsFail.type) {
              return of({ ...payload, ...{ error: (o as ActionErrorBase).error } });
            } else {
              return of(o.payload) as Observable<SafariBulkObject<T>>;
            }
          }),
          take(1)
        )
      )
    );

    return throwAbortOnError ? func.pipe(abortOnError()) : func;
  }

  deleteObjectOnce$<T extends SafariObject>(
    object: IReduxProvider<ISafariObjectState<T>, T>,
    id: SafariObjectId,
    overrides: DeleteObjectActionInfo<T> = null,
    throwAbortOnError = true
  ): Observable<{ id: SafariObjectId } & { error?: any }> {
    if (overrides?.options?.transferDialogOptions) {
      throwAbortOnError = false;
    }

    overrides = this._addactionIdToActionOverrides(overrides);
    const ok = this._actions.pipe(
      ofType(object.default.actions.deleteObjectSuccess),
      filter(o => SafariObject.idEqual(o.actionId, overrides.actionId))
    );
    const fail = this._actions.pipe(
      ofType(object.default.actions.deleteObjectFail),
      filter(o => SafariObject.idEqual(o.actionId, overrides.actionId))
    );

    const func = new Observable<void>(observer => {
      this.deleteObject(object, id, overrides);
      observer.next();
      observer.complete();
    }).pipe(
      mergeMap(() =>
        race(ok, fail).pipe(
          mergeMap(o => {
            if (o.type === object.default.actions.deleteObjectFail.type) {
              return of({ id: SafariObject.id(id), ...{ error: (o as ActionErrorBase).error } });
            } else {
              return of(o.payload);
            }
          }),
          take(1)
        )
      )
    );

    return throwAbortOnError ? func.pipe(abortOnError()) : func;
  }

  createOrUpdateObjectOnce$<T extends SafariObject>(
    object: IReduxProvider<ISafariObjectState<T>, T>,
    appModel: T,
    overrides: UpdateOrCreateActionInfo<T> = null,
    throwAbortOnError = true
  ): Observable<T & { error?: any }> {
    if (overrides?.options?.transferDialogOptions) {
      throwAbortOnError = false;
    }
    overrides = this._addactionIdToActionOverrides(overrides);
    const ok = this._actions.pipe(
      ofType(object.default.actions.createObjectSuccess, object.default.actions.updateObjectSuccess),
      filter(o => SafariObject.idEqual(o.actionId, overrides.actionId))
    );
    const fail = this._actions.pipe(
      ofType(object.default.actions.createOrUpdateObjectFail),
      filter(o => SafariObject.idEqual(o.actionId, overrides.actionId))
    );

    const func = new Observable<void>(observer => {
      this.createOrUpdateObject(object, appModel, overrides);
      observer.next();
      observer.complete();
    }).pipe(
      mergeMap(() =>
        race(ok, fail).pipe(
          mergeMap(o => {
            if (o.type === object.default.actions.createOrUpdateObjectFail.type) {
              return of({ ...appModel, ...{ error: (o as ActionErrorBase).error } });
            } else {
              return of(o.payload) as Observable<T>;
            }
          }),
          take(1)
        )
      )
    );

    return throwAbortOnError ? func.pipe(abortOnError()) : func;
  }

  createOrUpdateMultipleObjectsOnce$<T extends SafariObject>(
    object: IReduxProvider<ISafariObjectState<T>, T>,
    appModel: SafariBulkObject<T>,
    overrides: UpdateOrCreateMultipleActionInfo<T> = null,
    throwAbortOnError = true
  ): Observable<SafariBulkObject<T> & { error?: any }> {
    if (overrides?.options?.transferDialogOptions) {
      throwAbortOnError = false;
    }
    overrides = this._addactionIdToActionOverridesMulitple(overrides);
    const ok = this._actions.pipe(
      ofType(object.default.actions.createMultipleObjectsSuccess, object.default.actions.updateMultipleObjectsSuccess),
      filter(o => SafariObject.idEqual(o.actionId, overrides.actionId))
    );
    const fail = this._actions.pipe(
      ofType(object.default.actions.createOrUpdateMulitpleObjectsFail),
      filter(o => SafariObject.idEqual(o.actionId, overrides.actionId))
    );

    const func = new Observable<void>(observer => {
      this.createOrUpdateMultipleObjects(object, appModel, overrides);
      observer.next();
      observer.complete();
    }).pipe(
      mergeMap(() =>
        race(ok, fail).pipe(
          mergeMap(o => {
            if (o.type === object.default.actions.createOrUpdateMulitpleObjectsFail.type) {
              return of({ ...appModel, ...{ error: (o as ActionErrorBase).error } });
            } else {
              return of(o.payload) as Observable<SafariBulkObject<T>>;
            }
          }),
          take(1)
        )
      )
    );

    return throwAbortOnError ? func.pipe(abortOnError()) : func;
  }

  updatePartialObjectOnce$<T extends SafariObject>(
    object: IReduxProvider<ISafariObjectState<T>, T>,
    appModel: T,
    original: T,
    overrides: LoadObjectActionInfo<T> = null,
    throwAbortOnError = true
  ): Observable<T & { error?: any }> {
    overrides = this._addactionIdToActionOverrides(overrides);
    const ok = this._actions.pipe(
      ofType(object.default.actions.updatePartialObjectSuccess),
      filter(o => SafariObject.idEqual(o.actionId, overrides.actionId))
    );
    const fail = this._actions.pipe(
      ofType(object.default.actions.updatePartialObjectFail),
      filter(o => SafariObject.idEqual(o.actionId, overrides.actionId))
    );

    const func = new Observable<void>(observer => {
      this.updatePartialObject(object, appModel, original, overrides);
      observer.next();
      observer.complete();
    }).pipe(
      mergeMap(() =>
        race(ok, fail).pipe(
          mergeMap(o => {
            if (o.type === object.default.actions.updatePartialObjectFail.type) {
              return of({ ...appModel, ...{ error: (o as ActionErrorBase).error } });
            } else {
              return of(o.payload) as Observable<T>;
            }
          }),
          take(1)
        )
      )
    );

    return throwAbortOnError ? func.pipe(abortOnError()) : func;
  }

  updateObjectListOnce$<T extends SafariObject>(
    object: IReduxProvider<ISafariObjectState<T>, T>,
    originalList: T[],
    updatedList: T[],
    overrides: LoadObjectActionInfo<T> = null,
    throwAbortOnError = true
  ): Observable<{ originalList: T[]; updatedList: T[] } & { error?: any }> {
    const ok = this._actions.pipe(ofType(object.default.actions.updateObjectListSuccess));
    const fail = this._actions.pipe(ofType(object.default.actions.updateObjectListFail));

    const func = new Observable<void>(observer => {
      this.updateObjectList(object, originalList, updatedList, overrides);
      observer.next();
      observer.complete();
    }).pipe(
      mergeMap(() =>
        race(ok, fail).pipe(
          mergeMap(o => {
            if (o.type === object.default.actions.updateObjectListFail.type) {
              return of({ ...{ originalList, updatedList }, ...{ error: (o as ActionErrorBase).error } });
            } else {
              return of(o.payload) as Observable<{ originalList: T[]; updatedList: T[] }>;
            }
          }),
          take(1)
        )
      )
    );

    return throwAbortOnError ? func.pipe(abortOnError()) : func;
  }

  updateObjectList<T extends SafariObject>(object: IReduxProvider<ISafariObjectState<T>, T>, originalList: T[], updatedList: T[], overrides: LoadObjectActionInfo<T> = null) {
    if (overrides == null) {
      overrides = {};
    }
    const actionId = overrides.actionId ?? uuidv4();

    this._addToPendingUpdateObjectListAction(object, actionId);

    const sub = this._updateObjectListCompleteSubscriptions.get(object);
    if (sub == null) {
      this._updateObjectListCompleteSubscriptions.set(
        object,
        this._actions
          .pipe(
            ofType(object.default.actions.updateObjectListSuccess, object.default.actions.updateObjectListFail),
            tap(o => {
              if (o.actionId != null) {
                this._removeFromPendingUpdateObjectListAction(object, o.actionId);
              }
              if (o.type === object.default.actions.updateObjectListFail.type) {
                this._host.onUpdateObjectListFail(o as UpdateObjectListActionFailInfo<T> & Action<string>);
              }
            })
          )
          .subscribe()
      );
    }

    this._store.dispatch(object.default.actions.updateObjectList({ ...overrides, payload: { originalList, updatedList }, actionId }));
  }

  createOrUpdateObject<T extends SafariObject>(object: IReduxProvider<ISafariObjectState<T>, T>, appModel: T, overrides: UpdateOrCreateActionInfo<T> = null) {
    overrides = this._addactionIdToActionOverrides(overrides);

    this._addToPendingCreateUpdateObjectAction(object, overrides.actionId);

    const sub = this._updateObjectCompleteSubscriptions.get(object);
    if (sub == null) {
      this._updateObjectCompleteSubscriptions.set(
        object,
        this._actions
          .pipe(
            ofType(object.default.actions.createObjectSuccess, object.default.actions.updateObjectSuccess, object.default.actions.createOrUpdateObjectFail),
            tap(o => {
              if (o.actionId != null) {
                this._removeFromPendingCreateOrUpdateObjectAction(object, o.actionId);
              }
              if (o.type === object.default.actions.createOrUpdateObjectFail.type) {
                this._host.onCreateOrUpdateObjectFail(o as UpdateOrCreateActionFailInfo<T> & Action<string>);
              }
            })
          )
          .subscribe()
      );
    }

    this._store.dispatch(object.default.actions.createOrUpdateObject({ ...overrides, payload: appModel }));
  }
  createOrUpdateMultipleObjects<T extends SafariObject>(object: IReduxProvider<ISafariObjectState<T>, T>, appModel: SafariBulkObject<T>, overrides: UpdateOrCreateMultipleActionInfo<T> = null) {
    overrides = this._addactionIdToActionOverridesMulitple(overrides);

    this._addToPendingCreateUpdateObjectAction(object, overrides.actionId);

    if (appModel.objects.length > 1 && overrides.options?.transferDialogOptions) {
      this._store.dispatch(
        object['service']['safariReduxFileTransferObject'].default.actions.prepareForBulkTransfer({
          payload: {
            filesToAdd: appModel.objects.map((o, index) => ({
              id: o.id,
              displayFilename: overrides.options?.transferDialogOptions[index].displayName,
              actionId: overrides.actionId + '_' + index
            })),
            filesToRemove: []
          }
        })
      );
    }

    const sub = this._updateObjectCompleteSubscriptions.get(object);
    if (sub == null) {
      this._updateObjectCompleteSubscriptions.set(
        object,
        this._actions
          .pipe(
            ofType(object.default.actions.createMultipleObjectsSuccess, object.default.actions.updateMultipleObjectsSuccess, object.default.actions.createOrUpdateMulitpleObjectsFail),
            tap(o => {
              if (o.actionId != null) {
                this._removeFromPendingCreateOrUpdateObjectAction(object, o.actionId);
              }
              if (o.type === object.default.actions.createOrUpdateMulitpleObjectsFail.type) {
                // this._host.onCreateOrUpdateMultipleObjectsFail(o as UpdateOrCreateMultipleActionFailInfo<T> & Action<string>);
              }
            })
          )
          .subscribe()
      );
    }

    this._store.dispatch(object.default.actions.createOrUpdateMultipleObjects({ ...overrides, payload: appModel }));
  }
  updatePartialObject<T extends SafariObject>(object: IReduxProvider<ISafariObjectState<T>, T>, appModel: T, original: T, overrides: LoadObjectActionInfo<T> = null) {
    overrides = this._addactionIdToActionOverrides(overrides);

    this._addToPendingCreateUpdateObjectAction(object, overrides.actionId);

    const sub = this._updateObjectCompleteSubscriptions.get(object);
    if (sub == null) {
      this._updateObjectCompleteSubscriptions.set(
        object,
        this._actions
          .pipe(
            ofType(object.default.actions.updatePartialObjectSuccess, object.default.actions.updatePartialObjectFail),
            tap(o => {
              if (o.actionId != null) {
                this._removeFromPendingCreateOrUpdateObjectAction(object, o.actionId);
              }
              if (o.type === object.default.actions.updatePartialObjectFail.type) {
                this._host.onCreateOrUpdateObjectFail(o as UpdateOrCreateActionFailInfo<T> & Action<string>);
              }
            })
          )
          .subscribe()
      );
    }

    this._store.dispatch(object.default.actions.updatePartialObject({ ...overrides, payload: appModel }));
  }

  abortActions() {
    for (const key of Array.from(this._pendingCreateUpdateObjectActions.keys())) {
      const pendingCreateUpdateObjectactionIds = this._pendingCreateUpdateObjectActions.get(key);
      pendingCreateUpdateObjectactionIds.forEach(actionId => {
        this._store.dispatch(key.default.actions.createOrUpdateObject({ abort: actionId }));
      });
    }

    for (const key of Array.from(this._pendingLoadObjectActions.keys())) {
      const pendingLoadObjectactionIds = this._pendingLoadObjectActions.get(key);
      pendingLoadObjectactionIds.forEach(actionId => {
        this._store.dispatch(key.default.actions.loadObject({ abort: actionId }));
      });
    }
    for (const key of Array.from(this._pendingDeleteObjectActions.keys())) {
      const pendingDeleteObjectactionIds = this._pendingDeleteObjectActions.get(key);
      pendingDeleteObjectactionIds.forEach(actionId => {
        this._store.dispatch(key.default.actions.deleteObject({ abort: actionId }));
      });
    }

    for (const key of Array.from(this._pendingLoadListActions.keys())) {
      const pendingLoadObjectListactionIds = this._pendingLoadListActions.get(key);

      pendingLoadObjectListactionIds.forEach(actionId => {
        this._store.dispatch(key.default.actions.loadObjectList({ abort: actionId }));
      });
    }
    this._pendingCreateUpdateObjectActions.clear();
    this._pendingLoadObjectActions.clear();
    this._pendingLoadObjectBlockUiActions.clear();
    this._pendingLoadListActions.clear();
    this._pendingDeleteObjectActions.clear();
  }

  dispatchDropdownLoadActions(dropdown: SafariReduxDropdownObject<any>, ...args: any[]) {
    const argsAsArray = [...args];
    argsAsArray.forEach(o => this._store.dispatch(dropdown.default.actions.loadDropdown({ id: o as SafariObjectId })));
  }
  dispatchDropdownBulkLoadActions(dropdown: SafariReduxDropdownObject<any>, id: SafariObjectId, ...args: SafariObjectId[]) {
    const dropdownIds = [...args];
    this._store.dispatch(dropdown.default.actions.loadBulkDropdown({ id, dropdownIds: dropdownIds.map(x => SafariObject.id(x)) }));
  }
  dispatchDropdownClearActions(dropdown: SafariReduxDropdownObject<any>, ...args: any[]) {
    const argsAsArray = [...args];
    argsAsArray.forEach(o => this._store.dispatch(dropdown.default.actions.clearDropdown({ id: o as SafariObjectId })));
  }
  dispatchSearchLoadActions(...args) {
    const argsAsArray = [...args];
    argsAsArray.forEach(o => this._store.dispatch(this.searchReduxObject.default.actions.loadSearch({ id: o.id, query: o.query })));
  }
  dispatchSearchLoadAbortActions(...args) {
    const argsAsArray = [...args];
    argsAsArray.forEach(o => this._store.dispatch(this.searchReduxObject.default.actions.loadSearch({ abort: o })));
  }
  dispatchSearchClearActions(...args) {
    const argsAsArray = [...args];
    argsAsArray.forEach(o => this._store.dispatch(this.searchReduxObject.default.actions.clearSearch({ id: o })));
  }
}
